module.exports = __webpack_public_path__ + "img/cmdb5.4afe0fc7.png";